// src/schemas/pageSchema.js
import * as Yup from "yup";

export const pageSchema = Yup.object().shape({
  title: Yup.string()
    .trim()
    .required("Page title is required")
    .min(3, "Page title must be at least 3 characters")
    .max(100, "Page title cannot exceed 100 characters"),

  path: Yup.string()
    .trim()
    .required("Page path is required")
    .matches(
      /^\/[A-Za-z0-9\-_/]*$/,
      "Path must start with “/” and contain only letters, numbers, hyphens, underscores, or additional slashes"
    )
    .max(200, "Page path cannot exceed 200 characters"),

  contentIds: Yup.array()
    .of(Yup.string().required())
    .min(1, "Select at least one content")
    .required("Contents selection is required"),
});
